export default __webpack_public_path__ + "static/Paper-Recycling-122e12ec7e27539bf9a0589bd40db729.jpg";